// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1axrM","buttons":"styles_buttons__2B7gw"};